import api from '@/api/api';

export default {

  namespaced: true,

  state: {
    logedInUserInfo: '',
    logedInUserTokens: '',
    sucursalData: {},
    numeroDeCuentaQueSeEstaUsando: '',
  },
  mutations: {
    logIn(state, datos) {
      state.logedInUserInfo = datos.user;
      state.logedInUserTokens = datos.token;
    },
    logOut(state) {
      state.logedInUserInfo = '';
      state.logedInUserTokens = '';
    },
    destroyTokens(state) {
      state.logedInUserInfo = '';
      state.logedInUserTokens = '';
      state.sucursalData = {};
      state.numeroDeCuentaQueSeEstaUsando='';
    },
    relogIn(state, datos) {
      state.logedInUserInfo = datos.user;
      state.logedInUserTokens = datos.token;
    },
    getSucursalEnLaQueEstoy(state, datos) {
      state.sucursalData = datos;
    },
    asignaNumeroDeCuentaAUsar(state, datos) {
      state.numeroDeCuentaQueSeEstaUsando = datos;
    },
  },
  actions: {
    async logIn({
      commit,
    }, user) {
      try {
        const res = await api.logIn(user);
        if (res.data.user) {
          commit('logIn', res.data);
          return [true, 'das'];
        } return [false, res.data.INFO];
      } catch (error) {
        console.log(error);
      }
    },

    async getSucursalEnLaQueEstoy({
      commit,
    }, sucID) {
      try {
        const res = await api.getSucursalEnLaQueEstoy(sucID);
        if (res.data.DATOS) {
          commit('getSucursalEnLaQueEstoy', res.data.DATOS[0]);
          return true;
        } return false;
      } catch (error) {
        console.log(error);
      }
    },


    async cambiarDatosUsuario({
      commit,
    }, userDatos) {
      try {
        const res = await api.cambiarDatosUsuario(userDatos);
        if (res.data.INFO.cod == 200) {
          console.log('cambio exitoso');
          return [true, 'Contraseña actualizada exitosamente'];
        } else {
          console.log('error en cambio');
          return [false, 'Error al cambiar contraseña, revise sus datos nuevamente'];
        }
      } catch (error) {
        console.log(error);
      }
    },

    async relogIn({
      commit,
    }, userData) {
      try {
        const res = await api.relogIn(userData);
        if (res.data.user) {
          commit('relogIn', res.data);
          return true;
        } return false;
      } catch (error) {
        console.log(error);
      }
    },

    async logOut({
      commit,
    }, user) {
      try {
        const res = await api.logOut(user);
        if (res) {
          commit('logOut');
          commit('vecona/destroyVecona', '', { root: true });
          commit('cuentas/destroyCuentas', '', { root: true });
          commit('usuarios/destroyUserStore', '', { root: true });
          commit('fraccionesarancelarias/destroyFraccionesAStore', '', { root: true });
          commit('enviosRemitentes/destroyRemitente', '', { root: true });
          commit('enviosDestinatarios/destroyDestinatario', '', { root: true });
          commit('enviosInfoEnvio/destroyStoreInfoEnvio', '', { root: true });
          commit('enviosInfoEnvio/destroyinfoEnvioGeneradaDespues', '', { root: true });
          commit('sucursales/destroySucursalesStore', '', { root: true });
          commit('tarifas/destroyDescuentos', '', { root: true });
          commit('cuentas/destroyCuentas', '', { root: true });
          commit('sepomex/destroySepomex', '', { root: true });
          commit('remitentesRegistro/destroyRemitentes', '', { root: true });
          commit('remitentesRegistro/destroyRemitentesMostrador', '', { root: true });
          commit('destinatarioRegistro/destroyDestinatarios', '', { root: true });
          commit('destinatarioRegistro/destroyDestinatariosMostrador', '', { root: true });
          commit('contrato/destroyContrato', '', { root: true });
          commit('enviosInsercion/destroyHistorialEnvios', '', { root: true });
          commit('enviosConsultaMostrador/destroyEnviosMostrador', '', { root: true });
          return true;
        }
        return false;
      } catch (error) {
        console.log(error);
      }
    },

    async asignaNumeroDeCuentaAUsar({
      commit,
    },numDeCuenta) {
      commit('asignaNumeroDeCuentaAUsar',numDeCuenta);
    },

    async destroyTokens({
      commit,
    }) {
      try {
        commit('destroyTokens');
        return true;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
